import {LucideChevronDown} from "lucide-react";
import {Typography} from "../../ui/Typography";

export const FaqSection = () => { 
    return (
        <section id="veelgestelde-vragen" className="bg-surface-50 py-16 lg:py-24">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">

                <div className="text-center">
                    <span className="inline-block rounded-full bg-brand-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-brand-700">
                        Goed om te weten
                    </span>
                    <Typography as="h2" variant="h2" className="mt-4 font-display text-3xl md:text-4xl text-center">
                        Veelgestelde vragen
                    </Typography>
                </div>

                <div className="mt-10 space-y-3" id="faq-container">

                    <FaqItem
                        question="Is het echt lekvrij?"
                        answer="Ja! De rand van medische siliconen buigt om een veilige afdichting te vormen wanneer zachtjes tegen je lichaam gedrukt. Duizenden gebruikers vertrouwen erop dagelijks."
                    />

                    <FaqItem
                        question="Hoe maak ik het schoon?"
                        answer="Spoel gewoon af met water of gebruik een doekje. Voor een diepere reiniging kun je het koken of in het bovenste rek van je vaatwasser plaatsen."
                    />

                    <FaqItem
                        question="Past het bij mij?"
                        answer="De flexibele rand van Peesential plastuit past zich aan alle lichaamsvormen en -maten aan. Ongeacht je anatomie, het vormt een strakke, lekvrije afdichting."
                    />

                    <FaqItem
                        question="Is het discreet om mee te nemen?"
                        answer="Ja, het vouwt op in een klein zakje ter grootte van een make-up compact. Stop het in je zak of klik het aan je tas."
                    />

                </div>
            </div>
        </section>
    );
};


const FaqItem =({question, answer}) => {
    return (
        <details className="group bg-white rounded-2xl ring-1 ring-surface-200 transition-all
        hover:ring-surface-300 open:ring-brand-300 open:shadow-md open:shadow-brand-900/5">
            <summary className="flex items-center justify-between gap-4 p-5 cursor-pointer list-none focus-ring rounded-2xl">
              <span className="font-semibold text-surface-900 group-open:text-brand-700 transition-colors">
                  {question}
              </span>
                <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-surface-100 text-surface-600 group-open:bg-brand-100 group-open:text-brand-600 transition-colors">
                    <LucideChevronDown
                        className="h-5 w-5 group-open:rotate-180 transition-transform"
                    />
                </span>
            </summary>
            <div className="px-5 pb-5 -mt-1 text-sm leading-relaxed text-surface-700">
                {answer}
            </div>
        </details>
    );
};




















